/* ============================
   OMINOMI – Publisher overrides
   Keep all custom JS here so theme updates are easy to merge.
   ============================ */

(function () {
  let loading = false;
  let currentPage = 1;
  let observer = null;
  let sentinel = null;
  let shouldScrollToTopAfterUpdate = false;

  const $ = (sel, root = document) => root.querySelector(sel);

  function getGrid() {
    return document.getElementById('product-grid'); // UL
  }

  function getHolder() {
    return document.getElementById('InfiniteLoadMore');
  }

  function getButton() {
    return document.getElementById('InfiniteLoadMoreBtn');
  }

  function getPageFromUrl() {
    const url = new URL(window.location.href);
    const p = parseInt(url.searchParams.get('page') || '1', 10);
    return Number.isFinite(p) && p > 0 ? p : 1;
  }

  // Keep current filters/sort/search params; only set page
  function buildPageUrl(pageNum) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(pageNum));
    return url.toString();
  }

  function teardownObserver() {
    if (observer) observer.disconnect();
    observer = null;

    if (sentinel && sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    sentinel = null;
  }

  function ensureObserver() {
    const grid = getGrid();
    if (!grid) return;

    // Create a fresh sentinel each time (grid may be replaced by filter AJAX)
    teardownObserver();

    sentinel = document.createElement('li');
    sentinel.style.height = '1px';
    sentinel.style.listStyle = 'none';
    grid.appendChild(sentinel);

    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0] && entries[0].isIntersecting) {
          loadNext(); // auto-load
        }
      },
      { rootMargin: '1500px 0px' }
    );

    observer.observe(sentinel);
  }

  async function loadNext() {
    const holder = getHolder();
    const btn = getButton();
    const grid = getGrid();

    if (!holder || !btn || !grid) return;
    if (loading) return;

    // If the grid was replaced, re-init page baseline from URL
    if (grid.dataset.infiniteInit !== '1') {
      currentPage = getPageFromUrl();
      grid.dataset.infiniteInit = '1';
      ensureObserver();
    }

    const nextPage = currentPage + 1;
    const nextUrl = buildPageUrl(nextPage);

    loading = true;
    const originalText = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Loading…';

    try {
      const res = await fetch(nextUrl, { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.getElementById('product-grid');
      const newItems = newGrid ? newGrid.querySelectorAll('li.grid__item') : null;

      // No more products on next page → stop
      if (!newItems || newItems.length === 0) {
        btn.remove();
        teardownObserver();
        return;
      }

      // Insert before sentinel
      newItems.forEach((li) => grid.insertBefore(li, sentinel));

      // Advance page counter only after successful append
      currentPage = nextPage;

      btn.disabled = false;
      btn.textContent = originalText;
    } catch (e) {
      console.error('[InfiniteScroll] Load failed:', e);
      btn.disabled = false;
      btn.textContent = originalText;
    } finally {
      loading = false;
    }
  }

  function initInfiniteScroll() {
    const grid = getGrid();
    const holder = getHolder();
    const btn = getButton();

    if (!grid || !holder || !btn) return;

    // Mark this specific grid instance as initialized
    currentPage = getPageFromUrl();
    grid.dataset.infiniteInit = '1';

    ensureObserver();
  }

  // 1) Delegated click so it still works after filters replace DOM
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (!target) return;

    // Covers clicks on inner spans etc.
    const btn = target.closest('#InfiniteLoadMoreBtn');
    if (!btn) return;

    e.preventDefault();
    loadNext();
  });

  // 2) Detect facet/filter interactions and request scroll-to-top after the AJAX update
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!el) return;

    // Broad match for Publisher facets UI
    if (
      el.closest('#FacetFiltersForm') ||
      el.closest('facet-filters-form') ||
      el.closest('.facets') ||
      el.closest('.facets-vertical')
    ) {
      shouldScrollToTopAfterUpdate = true;
    }
  });

  // 3) Watch for grid replacement (filters/sort) and re-init
  const container = document.getElementById('ProductGridContainer') || document.body;
  const mo = new MutationObserver(() => {
    const grid = getGrid();
    const holder = getHolder();
    const btn = getButton();

    if (!grid || !holder || !btn) return;

    // If a new grid appeared, re-init + observer
    if (grid.dataset.infiniteInit !== '1') {
      initInfiniteScroll();
    } else {
      // grid exists; ensure observer exists after DOM shuffles
      if (!sentinel || !observer) ensureObserver();
    }

    // Scroll to top of grid after filter changes (nice UX)
    if (shouldScrollToTopAfterUpdate) {
      shouldScrollToTopAfterUpdate = false;
      const topEl = document.getElementById('MainContent') || grid;
      topEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  mo.observe(container, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', initInfiniteScroll);
})();



